import React from "react";
import ReactDOM from "react-dom";
import "./resources/style/index.scss";
import "bootstrap/dist/css/bootstrap.rtl.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { applyMiddleware, createStore } from "redux";
import rootReducer from "./store";
import { Provider } from "react-redux";
import ReduxThunk from "redux-thunk";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import { resources } from "./localization";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';


const lang = localStorage.getItem("lang");
i18n.use(initReactI18next).init({
  resources: resources,
  lng: lang,
  fallbackLng: "en",
});

const store = createStore(rootReducer, applyMiddleware(ReduxThunk));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
